import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import api from "services/api";

import { Page } from "v2/components";
import { ExcecaoView } from "./ExcecaoView";
import { ExcecaoHistorico } from "./ExcecaoHistorico";
import { getContractDisplayName } from "v2/utils/getContractDisplayName";

interface IResponse {
  id: string; //workspace_id
  workspaceRules?: Array<{
    params?: {
      payload?: {
        rules?: {
          rulesRegister?: {
            policyContractNumber?: string;
            type?: string;
          };
        };
      };
    };
  }>;
  sellerOrganization: {
    id: string;
    corporateName: string;
  };
  buyerOrganization: {
    id: string;
    corporateName: string;
  };
  product: {
    id: string;
    name: string;
    productType: string;
    supplierOrganization: {
      id: string;
      corporateName: string;
    };
  };
}

export function Excecao() {
  const { workspaceId, templateId } = useParams() as {
    workspaceId: string;
    templateId: string;
  };

  const { data, isFetching, isFetched, isError } = useQuery({
    queryKey: ["pageDetail", workspaceId],
    queryFn: () => api.get(`/v2/workspaces/${workspaceId}/get-details`),
    select: (data) => data.data.data as IResponse,
  });
  
  return (
    <>
      {!isFetched && isFetching && <div>Loading...</div>}
      {!isFetched && isError && <div>Error...</div>}
      {data && (() => {
        // Explicit derivation: only LIVRE_ADESAO when the rules register
        // says so. Anything else (missing rules, unknown type, etc.) falls
        // back to COMPULSORIO with a console warning so misconfigurations
        // surface during QA instead of being silently treated as compulsory.
        const declaredType = data.workspaceRules?.[0]?.params?.payload?.rules?.rulesRegister?.type;
        const contractType: 'COMPULSORIO' | 'LIVRE_ADESAO' = declaredType === 'LIVRE_ADESAO' ? 'LIVRE_ADESAO' : 'COMPULSORIO';
        if (declaredType !== 'LIVRE_ADESAO' && declaredType !== 'COMPULSORIO' && declaredType !== undefined) {
          console.warn(`Excecao: unknown contract type "${declaredType}" for workspace ${workspaceId}; defaulting to COMPULSORIO`);
        }
        return (
        <Page title={getContractDisplayName(data)} backRoute={`/v2/workspaces/${workspaceId}/templates/${templateId}/movements-check`}>
          <Page.Tab name="Atividades">
            <ExcecaoView contractType={contractType} />
          </Page.Tab>
          <Page.Tab name="Histórico">
            <ExcecaoHistorico />
          </Page.Tab>
          <Page.Tab name="Contrato" disabled />
        </Page>
        );
      })()}
    </>
  )
}
